/**
 * Imports
 */
import { VibrantIcon } from 'components';
import { VibrantIconTypes } from 'components/VibrantIcon/VibrantIcon';
import * as React from 'react';
import { css } from 'styled-components';

import { styled } from 'theme';
import { StringLiteralPick } from 'utils';
import { SoftPos } from 'types/softpos';

/**
 * Styling
 */
const CARD_CSS: { [key in CardSizes]: any } = {
  lg: css`
    height: 42px;
    width: 64px;
  `,
  md: css`
    height: 30px;
    width: 48px;
  `,
  sm: css`
    height: 22px;
    width: 32px;
  `,
};
const Rectangle = styled.div<{ size: keyof typeof CardSizes }>`
  background-color: ${({ theme }) => theme.colors.Background.Secondary};
  border-radius: 4px;
  ${({ size }) => size && CARD_CSS[size]}

  display: flex;
  justify-content: center;
  align-items: center;
`;
const Rounded = styled.div<{ card: SoftPos.CardSource }>`
  background-color: ${({ theme, card }) =>
    card === 'V' ? theme.colors.Shades.Blue100 : theme.colors.Shades.Orange100};
  border-radius: 50%;
  height: 48px;
  width: 48px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

/**
 * Types
 */
export type CardTypes = StringLiteralPick<
  VibrantIconTypes,
  'visa' | 'master-card'
>;
export type CardSingleTypes = StringLiteralPick<
  VibrantIconTypes,
  'visa-single' | 'master-card-single'
>;
export type CardLookupType = { [key in SoftPos.CardSource]: CardTypes };
export type CardSingleLookupType = {
  [key in SoftPos.CardSource]: CardSingleTypes;
};
const CARD_MAPPER: CardLookupType = {
  M: 'master-card',
  V: 'visa',
};
const CARD_MAPPER_SINGLE: CardSingleLookupType = {
  M: 'master-card-single',
  V: 'visa-single',
};
// export type CardSizes = 'sm' | 'md' | 'lg';

export enum CardSizes {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}
export interface CreditCardProps {
  card: SoftPos.CardSource;
  size?: keyof typeof CardSizes;
  rounded?: boolean;
}

/**
 * CreditCard component
 */
const CreditCard: React.FC<CreditCardProps> = ({ card, size, rounded }) => {
  return (
    <>
      {rounded ? (
        <Rounded card={card}>
          <VibrantIcon icon={CARD_MAPPER_SINGLE[card]} size={20} />
        </Rounded>
      ) : (
        <Rectangle size={size ? size : 'md'}>
          <VibrantIcon
            icon={CARD_MAPPER[card]}
            size={size === 'sm' ? 12 : size === 'lg' ? 24 : 20}
          />
        </Rectangle>
      )}
    </>
  );
};

/**
 * Exports
 */
export { CreditCard };
